"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2045],{

/***/ 2045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_DetailSchedule; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/TravelInfoPopup.tsx + 1 modules
var TravelInfoPopup = __webpack_require__(96434);
// EXTERNAL MODULE: ./components/style/detailpackage/detailitinerary.tsx
var detailitinerary = __webpack_require__(11458);
// EXTERNAL MODULE: ./components/style/detailpackage/itinerarytemplate.tsx
var itinerarytemplate = __webpack_require__(20394);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/editor/index.tsx
var editor = __webpack_require__(58771);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 3 modules
var layout = __webpack_require__(47178);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventScheduleFlight.ts
var useEventScheduleFlight = __webpack_require__(85777);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventScheduleTrip.ts
var useEventScheduleTrip = __webpack_require__(28963);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventTourDetail.ts
var useEventTourDetail = __webpack_require__(93113);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/schedule/TemplateTabs.tsx
var TemplateTabs = __webpack_require__(93293);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/DailySchedule.tsx























var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var DepartDayComponent = function(day) {
    var ref;
    var ref1 = day.dayTimes[0], meetAirDivi = ref1.meetAirDivi, meetAirTm = ref1.meetAirTm, meetAirPlace = ref1.meetAirPlace, meetAirTelNo = ref1.meetAirTelNo, meetAirImgUrl = ref1.meetAirImgUrl, meetAirNote = ref1.meetAirNote;
    var ref2 = day.dayTimes[0], outDeprtCityNm = ref2.outDeprtCityNm, outDeprtTm = ref2.outDeprtTm, outArrvTm = ref2.outArrvTm, outDayDiff = ref2.outDayDiff, trTp = ref2.trTp, dayNo = ref2.dayNo, evStartDt = ref2.evStartDt, outArrvCityNm = ref2.outArrvCityNm;
    var tourDate = dayjs_min_default()(evStartDt).add(dayNo - 1, "day");
    var arriveDate = tourDate.add(outDayDiff, "day");
    if (trTp !== "A") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var filghtFilter = (ref = day.filght) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
        return v.immigDivi === "OD";
    }); // 출국 필터
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightTimeBox */.lp, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* Departure */.bS, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightCountry */.eb, {
                                children: "".concat(outDeprtCityNm || "", " 출발")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightTime */.Wb, {
                                children: outDeprtTm === null || outDeprtTm === void 0 ? void 0 : outDeprtTm.replace(/(\d{2})(\d{2})/g, "$1:$2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightDate */.xs, {
                                children: [
                                    tourDate.format("YYYY.MM.DD"),
                                    "(",
                                    daykor[tourDate.day()],
                                    ")"
                                ]
                            })
                        ]
                    }),
                    (filghtFilter === null || filghtFilter === void 0 ? void 0 : filghtFilter.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* StopoverIconBox */.Q2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* StopoverIcon */.rH, {
                                children: [
                                    "경유 ",
                                    filghtFilter.length,
                                    "회"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* TransitWrap */.pM, {
                                children: filghtFilter.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* TransitText */.Wx, {
                                        children: item.cityKorNm
                                    }, index);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightIconBox */.mV, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* Arrival */.aP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightCountry */.eb, {
                                children: "".concat(outArrvCityNm || "", " 도착")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightTime */.Wb, {
                                children: outArrvTm === null || outArrvTm === void 0 ? void 0 : outArrvTm.replace(/(\d{2})(\d{2})/g, "$1:$2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightDate */.xs, {
                                children: [
                                    arriveDate.format("YYYY.MM.DD"),
                                    "(",
                                    daykor[arriveDate.day()],
                                    ")",
                                    outDayDiff > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* AddDate */.Oc, {
                                        children: "+".concat(outDayDiff, "일")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            meetAirDivi !== "M0000" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* MeetingInfoBox */.s_, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "출발 전 공항미팅안내"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* MeetingList */.ce, {
                        children: [
                            meetAirTm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                        children: "미팅 일시"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        children: meetAirTm
                                    })
                                ]
                            }),
                            meetAirPlace && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                        children: "미팅 장소"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        dangerouslySetInnerHTML: {
                                            __html: meetAirPlace
                                        }
                                    })
                                ]
                            }),
                            meetAirTelNo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                        children: "담당자 연락처"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        children: meetAirTelNo
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* MeetingEdior */._s, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                children: meetAirNote && meetAirNote
                            }),
                            meetAirImgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL, "/").concat(meetAirImgUrl),
                                alt: "미팅장소"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/** 출발일(1일차) 추가 정보 */ var DepartDay = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule DepartDay Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartDayComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var ArriveDayComponent = function(day) {
    var ref;
    var ref1 = day.dayTimes[0], inDeprtCityNm = ref1.inDeprtCityNm, inArrvCityNm = ref1.inArrvCityNm, inDeprtTm = ref1.inDeprtTm, inArrvTm = ref1.inArrvTm, trTp = ref1.trTp, inDayDiff = ref1.inDayDiff, evArriveDt = ref1.evArriveDt;
    if (trTp !== "A") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var arriveDate = dayjs_min_default()(evArriveDt);
    var filghtFilter = (ref = day.filght) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
        return v.immigDivi === "IA";
    }); // 입국 필터
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightTimeBox */.lp, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* Departure */.bS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightCountry */.eb, {
                            children: "".concat(inDeprtCityNm || "", " 출발")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightTime */.Wb, {
                            children: inDeprtTm === null || inDeprtTm === void 0 ? void 0 : inDeprtTm.replace(/(\d{2})(\d{2})/g, "$1:$2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightDate */.xs, {
                            children: [
                                arriveDate.add(-inDayDiff, "day").format("YYYY.MM.DD"),
                                "(",
                                daykor[arriveDate.add(-inDayDiff, "day").day()],
                                ")"
                            ]
                        })
                    ]
                }),
                (filghtFilter === null || filghtFilter === void 0 ? void 0 : filghtFilter.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* StopoverIconBox */.Q2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* StopoverIcon */.rH, {
                            children: [
                                "경유 ",
                                filghtFilter.length,
                                "회"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* TransitWrap */.pM, {
                            children: filghtFilter.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* TransitText */.Wx, {
                                    children: item.cityKorNm
                                }, index);
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightIconBox */.mV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* Arrival */.aP, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightCountry */.eb, {
                            children: "".concat(inArrvCityNm || "", " 도착")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* FlightTime */.Wb, {
                            children: inArrvTm === null || inArrvTm === void 0 ? void 0 : inArrvTm.replace(/(\d{2})(\d{2})/g, "$1:$2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* FlightDate */.xs, {
                            children: [
                                arriveDate.format("YYYY.MM.DD"),
                                "(",
                                daykor[arriveDate.day()],
                                ")",
                                inDayDiff > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* AddDate */.Oc, {
                                    children: "+".concat(inDayDiff, "일")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/** 도착일 추가정보 */ var ArriveDay = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule ArriveDay Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArriveDayComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var TimeScheduleComponent = function(param) {
    var times = param.times;
    var ref = (0,react.useState)(false), playing = ref[0], setPlaying = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: times.map(function(item, index) {
            var tmNm = item.tmNm, tmTitle = item.tmTitle, tmContent = item.tmContent, trvVimeoUrl = item.trvVimeoUrl, endInfoImgUrl = item.endInfoImgUrl, tourDetails = item.tourDetails, cityCd = item.cityCd, cityNm = item.cityNm, viCityNm = item.viCityNm;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    (index === 0 || index > 0 && times[index - 1].cityCd !== cityCd) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* LocationTitle */.mA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                            cityNm,
                            viCityNm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "*",
                                    viCityNm
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* LocationText */.aX, {
                        children: [
                            tmNm && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tmNm
                            }),
                            " ",
                            tmTitle
                        ]
                    }),
                    tmContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* EditorBoxWrap */.LO, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                            dangerouslySetInnerHTML: {
                                __html: tmContent
                            }
                        })
                    }),
                    tourDetails.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* TemplateWrap */.SX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerarytemplate/* TemplateList */.HP, {
                            children: tourDetails.map(function(detail, detailIndex) {
                                return /*#__PURE__*/ (0,react.createElement)(TemplateTabs/* TourDetailTemplate */.BK, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
                                    key: detailIndex
                                }));
                            })
                        })
                    }),
                    endInfoImgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* ImgBox */.tG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(endInfoImgUrl),
                            alt: "이미지"
                        })
                    }),
                    trvVimeoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* PlayBox */.oe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            url: trvVimeoUrl,
                            width: "100%",
                            height: "100%",
                            playing: playing,
                            onPlay: function() {
                                return setPlaying(true);
                            },
                            onPause: function() {
                                return setPlaying(false);
                            },
                            volume: 0,
                            muted: true,
                            controls: true
                        })
                    })
                ]
            }, index);
        })
    });
};
var TimeSchedule = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule TimeSchedule Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeScheduleComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DayInformationComponent = function(day) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref[0];
    var accommYn = day.accommYn, accommNote = day.accommNote, accommNm = day.accommNm, foodBYn = day.foodBYn, foodLYn = day.foodLYn, foodDYn = day.foodDYn, foodB = day.foodB, foodL = day.foodL, foodD = day.foodD, accommInfoId = day.accommInfoId;
    var openTravelInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var data, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e.preventDefault();
                _tmp = {};
                data = (_tmp.trvCd = "20", _tmp.trvInfoId = accommInfoId, _tmp.infoApiUrl = "/api/event-info/".concat(accommInfoId, "/residence"), _tmp);
                open(function(prop) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelInfoPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                        trv: data
                    }));
                });
                return [
                    2
                ];
            });
        });
        return function openTravelInfo(e) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(accommYn || accommNote || accommNm || foodBYn === "Y" || foodLYn === "Y" || foodDYn === "Y")) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var Lodgment = function() {
        if (accommYn === "Y") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                    dangerouslySetInnerHTML: {
                        __html: "-미정 ".concat((accommNote === null || accommNote === void 0 ? void 0 : accommNote.replace(/\r\n/g, "<br/>")) || "")
                    }
                })
            });
        } else if (accommNm && accommYn !== "Y" && (accommInfoId || "").length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: openTravelInfo,
                        children: accommNm
                    }),
                    accommNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: accommNote.replace(/\r\n/g, "<br/>")
                    })
                ]
            });
        } else {
            if (!accommNm && !accommNote) return /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                children: "-"
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                children: [
                    accommNm && accommNm,
                    accommNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: accommNote.replace(/\r\n/g, "<br/>")
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* SummaryInfo */.T7, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: "숙박"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lodgment, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: "식사"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* MealList */.YJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                            children: "[조식]"
                                        }),
                                        " ",
                                        foodB || "-"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                            children: "[중식]"
                                        }),
                                        " ",
                                        foodL || "-"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                            children: "[석식]"
                                        }),
                                        " ",
                                        foodD || "-"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/** 숙박 식사 정보 */ var DayInformation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule DayInformation Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DayInformationComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DayScheduleComponent = function(day) {
    var dayNo = day.dayNo, evStartDt = day.evStartDt, dayLocationInfo = day.dayLocationInfo, dayTimes = day.dayTimes, lastDay = day.lastDay, filght = day.filght;
    var tourDate = dayjs_min_default()(evStartDt).add(dayNo - 1, "day");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* ScheduleTitle */.Hr, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            dayNo,
                            "일차"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            tourDate.format("YYYY.MM.DD"),
                            "(",
                            daykor[tourDate.day()],
                            ") - ",
                            dayLocationInfo
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* ScheduleContent */.XO, {
                children: [
                    dayTimes.length > 0 && dayNo === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartDay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, day), {
                        filght: filght
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* StepWrap */.hW, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* Location */.Ye, {
                            children: dayTimes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSchedule, {
                                times: dayTimes
                            })
                        })
                    }),
                    dayTimes.length > 0 && dayNo === lastDay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArriveDay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, day), {
                        filght: filght
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DayInformation, (0,_object_spread/* default */.Z)({}, day))
                ]
            })
        ]
    });
};
var DaySchedule = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule DaySchedule Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DayScheduleComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DailyScheduleComponent = function(param) {
    var evCd = param.evCd, isFixed = param.isFixed;
    var ref;
    var goodsCd = evCd === null || evCd === void 0 ? void 0 : evCd.substring(0, 7);
    var scheduleTripFetch = (0,useEventScheduleTrip/* default */.Z)(evCd, goodsCd);
    var tourDetailsFetch = (0,useEventTourDetail/* default */.Z)(evCd);
    var eventScheduleFlight = (0,useEventScheduleFlight/* default */.Z)(evCd); // 출입국 경유지 api
    var filght = (ref = eventScheduleFlight.data) === null || ref === void 0 ? void 0 : ref.body;
    var days = (0,react.useMemo)(function() {
        var ref;
        if (!scheduleTripFetch.isFetched || !tourDetailsFetch.isFetched) return null;
        var _body = scheduleTripFetch.data.body, scheduleDetail = _body.scheduleDetail, scheduleDetailTm = _body.scheduleDetailTm;
        var tourDetails = (ref = tourDetailsFetch.data) === null || ref === void 0 ? void 0 : ref.body;
        return scheduleDetail.reduce(function(acc, detail) {
            var dayTmList = scheduleDetailTm.filter(function(tm) {
                tm.tourDetails = tourDetails.filter(function(v) {
                    return v.tmSeq === tm.tmSeq;
                });
                return tm.dayNo === detail.dayNo;
            });
            detail.dayTimes = dayTmList;
            detail.dayLocationInfo = detail.dayTimes.reduce(function(cityNmAcc, cur) {
                cityNmAcc.indexOf(cur.cityNm) === -1 && cityNmAcc.push(cur.cityNm);
                return cityNmAcc;
            }, []).join("/");
            acc.push(detail);
            return acc;
        }, []);
    }, [
        scheduleTripFetch,
        tourDetailsFetch
    ]);
    var ref1 = (0,react.useState)(0), activeTab = ref1[0], setActiveTab = ref1[1];
    var ScrollToId = function(id) {
        return function(e) {
            e.preventDefault();
            var element = document.getElementById(id);
            if (element) element.scrollIntoView({
                behavior: "smooth"
            });
        };
    };
    /* tab active */ var handleScroll = (0,react.useCallback)(function() {
        var contentsElements = Array.from(document.querySelectorAll("[id^=dayContents]"));
        contentsElements.forEach(function(el, index) {
            if (el && window.scrollY + 202 > window.scrollY + el.getBoundingClientRect().top) {
                setActiveTab(index);
            }
        });
        // last element 처리
        var scrollHeight = document.documentElement.scrollHeight;
        var scrollTop = document.documentElement.scrollTop;
        var clientHeight = document.documentElement.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight) {
            setActiveTab(contentsElements.length - 1);
        }
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    /* x scroll */ var handleMovementTab = (0,react.useCallback)(function() {
        var _lastTabLeft = document.getElementById("dayTab".concat(days.length - 1)).offsetLeft;
        var _containerWrapWidth = document.getElementById("__dayContainerWrap").clientWidth;
        // x스크롤 필요 없는 경우 return
        if (_containerWrapWidth > _lastTabLeft) return;
        var _activeTab = document.getElementById("dayTab".concat(activeTab));
        var _activeTabLeft = _activeTab.offsetLeft;
        var _activeTabWidth = _activeTab.offsetWidth;
        var container = document.getElementById("__dayContainer");
        var scrollLeft = _activeTabLeft - _containerWrapWidth + _activeTabWidth + 73;
        container.scrollLeft = scrollLeft;
    }, [
        activeTab
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            return handleMovementTab();
        }, 500);
        return function() {
            clearTimeout(timer);
        };
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* Wrap */.Eq, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* SubTitleWrap */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "여행 일정"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* NoteBox */.ug, {
                icon: "point",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "참고하세요"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "여행 일정은 계약 체결 시 예상하지 못한 부득이한 사정 등이 발생하는 경우 여행자의 사전 동의를 거쳐 변경될 수 있음을 양지하여 주시기 바랍니다."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* DayList */.dn, {
                isFixed: isFixed,
                id: "__dayContainerWrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    id: "__dayContainer",
                    children: days && days.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            id: "dayTab".concat(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailitinerary/* DayListItem */.jJ, {
                                onClick: ScrollToId("dayContents".concat(index)),
                                isActive: activeTab === index,
                                href: "dayContents".concat(index),
                                children: [
                                    item.dayNo,
                                    "일차"
                                ]
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* ScheduleBox */.lX, {
                children: days && days.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailitinerary/* ScheduleIitem */.vi, {
                        id: "dayContents".concat(index),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DaySchedule, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            lastDay: days.length,
                            filght: filght
                        }))
                    }, index);
                })
            })
        ]
    });
};
// 일차별 일정
var DailySchedule = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DailySchedule Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyScheduleComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var schedule_DailySchedule = (DailySchedule);

// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/ReportPopup.tsx + 1 modules
var ReportPopup = __webpack_require__(87947);
// EXTERNAL MODULE: ./components/style/detailpackage/reviewpopup.tsx
var reviewpopup = __webpack_require__(5955);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 8 modules
var desktop_button = __webpack_require__(36432);
// EXTERNAL MODULE: ./hooks/services/queries/account/useCustomerMe.ts + 1 modules
var useCustomerMe = __webpack_require__(38186);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EpisodePopup.tsx
/** api */ 












var EpisodePopup = function(props) {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref1[0];
    var travrvNo = props.travrvNo, episodeList = props.episodeList, close = props.close;
    var ref2 = (0,react.useState)(travrvNo), cuurentNo = ref2[0], setCuurentNo = ref2[1];
    var episode = episodeList.find(function(v) {
        return v.travrvNo === cuurentNo;
    }) || null;
    /** 이전 | 다음 travrvNo 데이터 추출 */ var getTargetNo = (0,react.useCallback)(function(divi) {
        var ref;
        var direction = divi === "next" ? 1 : -1;
        var currentIndex = episodeList.findIndex(function(v) {
            return v.travrvNo === cuurentNo;
        });
        return ((ref = episodeList[currentIndex + direction]) === null || ref === void 0 ? void 0 : ref.travrvNo) || null;
    }, [
        cuurentNo
    ]);
    var signin = (0,useCustomerMe/* default */.ZP)();
    var isSignin = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.nonUser) === false;
    var openReport = function() {
        if ((episode === null || episode === void 0 ? void 0 : episode.reportYn) === "Y") {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    text: "신고사유 검토중인 게시물입니다.<br/>빠른 시일 내에 처리하겠습니다."
                }));
            });
            return;
        }
        if (isSignin) {
            open(function(overlay) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                    reportId: travrvNo,
                    reportType: "EPISODE"
                }));
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    afterConfirm: function() {
                        return LoginUtil.login();
                    }
                }));
            });
        }
    };
    var _custNm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: episode && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* Wrap */.Eq, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviewpopup/* Popup */.GI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviewpopup/* Header */.h4, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "여행후기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* PopupCloseButton */.sz, {
                                onClose: close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviewpopup/* Content */.VY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviewpopup/* PostMeta */.SP, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            episode.bestYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* BestTag */.uN, {
                                                children: "베스트"
                                            }),
                                            episode.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviewpopup/* User */.n5, {
                                                children: [
                                                    (_custNm = episode.custNm) !== null && _custNm !== void 0 ? _custNm : "- ",
                                                    "님"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* Date */.Ej, {
                                                children: dayjs_min_default()(episode.regDt).format("YYYY.MM.DD")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* EditorWrap */.ls, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                    dangerouslySetInnerHTML: {
                                        __html: episode.contents.replace(/\n/g, "<br />")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* ReportWrap */.nI, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* ReportBtn */.uQ, {
                                    onClick: openReport,
                                    children: "신고하기"
                                })
                            })
                        ]
                    }),
                    getTargetNo("prev") && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* SlideButton */.At, {
                        direction: "prev",
                        onClick: function() {
                            return setCuurentNo(getTargetNo("prev"));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "이전 여행후기 보기"
                        })
                    }),
                    getTargetNo("next") && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviewpopup/* SlideButton */.At, {
                        direction: "next",
                        onClick: function() {
                            return setCuurentNo(getTargetNo("next"));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "다음 여행후기 보기"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var desktop_EpisodePopup = (EpisodePopup);

// EXTERNAL MODULE: ./components/style/detailpackage/reviews.tsx
var reviews = __webpack_require__(67341);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/review/useReviewEpisode.ts
var useReviewEpisode = __webpack_require__(99839);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/Episode.tsx







var EPISODE_COUNT = 10;
/** 여행후기 */ var EpisodeComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var goodsCd = evCd.split("-")[0];
    // const [open] = useOverlay();
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(null), detailTravrvNo = ref2[0], setDetailTravrvNoNo = ref2[1];
    var handleDetailClose = function() {
        return setDetailTravrvNoNo(null);
    };
    /* 여행후기 데이터 */ var reviewEpisodeFetch = (0,useReviewEpisode/* default */.ZP)(goodsCd);
    var episodeList = ((ref = reviewEpisodeFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var totalCount = episodeList.length || 0;
    var pageCount = EPISODE_COUNT * page;
    var list = (0,react.useMemo)(function() {
        return episodeList.slice(0, EPISODE_COUNT * page);
    }, [
        episodeList,
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviews/* TravelReviewWrap */.i1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* CategoryTitle */.gI, {
                        $line: true,
                        children: "여행후기(".concat(totalCount, ")")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* TravelReviewList */.Rx, {
                        children: list.map(function(episode) {
                            var regDt = episode.regDt, custNm = episode.custNm, title = episode.title, travrvNo = episode.travrvNo;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                onClick: function() {
                                    return setDetailTravrvNoNo(travrvNo);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviews/* TravelReviewListItem */.cL, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* TravelReviewListTitle */.kO, {
                                            dangerouslySetInnerHTML: {
                                                __html: title
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(reviews/* TravelReviewListInfo */.q, {
                                            children: [
                                                custNm !== null && custNm !== void 0 ? custNm : "- ",
                                                "님"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* TravelReviewListInfo */.q, {
                                            children: dayjs_min_default()(regDt).format("YYYY.MM.DD")
                                        })
                                    ]
                                })
                            }, travrvNo);
                        })
                    }),
                    list.length < totalCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* LoadMoreBtn */.CF, {
                        onClick: function() {
                            return setPage(page + 1);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "더보기(".concat(pageCount, "/").concat(totalCount, ")")
                        })
                    }),
                    reviewEpisodeFetch.isFetched && episodeList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* WriteRequest */.$0, {
                        children: "아직 작성된 후기가 없습니다."
                    })
                ]
            }),
            detailTravrvNo && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_EpisodePopup, {
                travrvNo: detailTravrvNo,
                episodeList: episodeList,
                close: handleDetailClose
            })
        ]
    });
};
var Episode = function(param) {
    var evCd = param.evCd;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeComponent, {
            evCd: evCd
        })
    });
};
/* harmony default export */ var schedule_Episode = (Episode);

// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/schedule/Review.tsx
var Review = __webpack_require__(1560);
// EXTERNAL MODULE: ./components/style/detailpackage/productinformation.tsx
var productinformation = __webpack_require__(69338);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 4 modules
var popup = __webpack_require__(16628);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventNotice.ts
var useEventNotice = __webpack_require__(64767);
// EXTERNAL MODULE: ./components/style/detailpackage/hotelguide.tsx
var hotelguide = __webpack_require__(75907);
// EXTERNAL MODULE: ./components/style/slide/index.tsx
var slide = __webpack_require__(91587);
// EXTERNAL MODULE: ./framework/ui/desktop/slide/index.ts + 6 modules
var desktop_slide = __webpack_require__(93774);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventHotelResort.ts
var useEventHotelResort = __webpack_require__(58553);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventInfoImages.ts
var useEventInfoImages = __webpack_require__(64853);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventInfoVideos.ts
var useEventInfoVideos = __webpack_require__(12621);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/popup/ImageVideoPop.tsx
var ImageVideoPop = __webpack_require__(44240);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/HotelResort.tsx


















var HotelResortImagesComponent = function(props) {
    var ref, ref1;
    var accommInfoId = props.accommInfoId, evCd = props.evCd;
    var hotelImagesFetch = (0,useEventInfoImages/* default */.Z)(accommInfoId, "hotel", evCd);
    var hotelVideoFetch = (0,useEventInfoVideos/* default */.Z)(accommInfoId, "hotel", evCd);
    var images = ((ref = hotelImagesFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var videos = ((ref1 = hotelVideoFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body) || [];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    var handleImageVideoPop = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageVideoPop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                images: images,
                videos: videos,
                title: "호텔/리조트 이미지 상세보기"
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: images.length + videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_slide/* GuideSlide */.Zj, {
            perView: 2,
            spaceBetween: 12,
            children: [
                videos.length > 0 && videos.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                            types: "movie",
                            onClick: handleImageVideoPop,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                width: "100%",
                                height: "283px",
                                src: item.vimeoThum1,
                                alt: item.vimeoNote
                            })
                        })
                    }, "video".concat(index));
                }),
                images.length > 0 && images.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                            onClick: handleImageVideoPop,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                width: "100%",
                                height: "283px",
                                src: item.imageThum2,
                                alt: item.imageNote
                            })
                        })
                    }, "image".concat(index));
                }),
                images.length + videos.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                            width: "100%",
                            height: "283px",
                            src: "",
                            alt: ""
                        })
                    })
                }, "noImg")
            ]
        })
    });
};
var HotelResortImages = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HotelResort HotelResortImages Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelResortImagesComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var HotelResortComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var hotelResortFetch = (0,useEventHotelResort/* default */.ZP)(evCd);
    var hotelResort = (ref = hotelResortFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var ref1 = (0,react.useState)(0), active = ref1[0], setActive = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hotelResort && hotelResort.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(hotelguide/* Wrap */.Eq, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "호텔/리조트"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hotelguide/* Tab */.OK, {
                    children: hotelResort.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(hotelguide/* TabItem */.E2, {
                            active: active === index,
                            onClick: function() {
                                return setActive(index);
                            },
                            children: item.tabNm
                        }, index);
                    })
                }),
                hotelResort.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(hotelguide/* HotelInfoWrap */.V_, {
                        active: active === index,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: item.korNm
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelResortImages, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                evCd: evCd
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                margin: "40px 0 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                            children: "호텔/리조트 정보"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "15%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "85%"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                (item === null || item === void 0 ? void 0 : item.benfInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "혜택 / 특전"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.benfInfo
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.amenityInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "편의시설"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.amenityInfo
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.restaurantInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "레스토랑"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.restaurantInfo
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.activityInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "액티비티"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item === null || item === void 0 ? void 0 : item.activityInfo
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.kidsOnlyServ) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "키즈전용"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.kidsOnlyServ
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.etcInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            children: "기타 안내"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.etcInfo
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
var HotelResort = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HotelResort Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelResortComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var schedule_HotelResort = (HotelResort);

;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/Information.tsx
















var GoodsInformationComponent = function(param) {
    var goodsInfo = param.goodsInfo;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,react.useState)(false), activeButton = ref1[0], setActiveButton = ref1[1];
    var elementHeight = showMore ? "auto" : "800px";
    var buttonText = showMore ? "닫기" : "더 보기";
    var handleButton = function() {
        setShowMore(!showMore);
        if (showMore) {
            var $goodsWrap = document.querySelector("#__goodsWrap");
            // 140 fixed tab 보정치... 나중에 수정필요..
            var $target = $goodsWrap.getBoundingClientRect().top + window.scrollY - 140;
            window.scrollTo({
                top: $target,
                behavior: "smooth"
            });
        }
    };
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var $goodsInfo = document.querySelector("#__goodsInfo");
            if ($goodsInfo.getBoundingClientRect().height >= 800) {
                setActiveButton(true);
            } else {
                setActiveButton(false);
            }
        }, 500);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* EditorWrap */.ls, {
                elementHeight: elementHeight,
                id: "__goodsWrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                    dangerouslySetInnerHTML: {
                        __html: goodsInfo
                    },
                    id: "__goodsInfo"
                })
            }),
            activeButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_button/* PlusMoreButton */.sp, {
                onClick: handleButton,
                children: [
                    "상품 안내 ",
                    buttonText
                ]
            })
        ]
    });
};
// 상품안내
var GoodsInformation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Information GoodsInformation Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodsInformationComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var InformationComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var ref1 = (0,react.useState)(false), playing = ref1[0], setPlaying = ref1[1];
    var noticeFetch = (0,useEventNotice/* default */.ZP)(evCd);
    var notice = (ref = noticeFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    var handleSearcharge = function(e) {
        e.preventDefault();
        open(function(overlay) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                title: "SURCHARGE 안내",
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(notice.stretAttaFileKey),
                    alt: "써차지"
                })
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: notice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                notice.vimeoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* PlayBox */.oe, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        url: notice.vimeoUrl,
                        width: "100%",
                        height: "100%",
                        playing: playing,
                        onPlay: function() {
                            return setPlaying(true);
                        },
                        onPause: function() {
                            return setPlaying(false);
                        },
                        volume: 0,
                        muted: true,
                        controls: true
                    })
                }),
                notice.keyInfoImageList.length > 0 && notice.keyInfoImageList.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* ImgEditor */.wG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.pcAttaFilePath),
                            alt: "핵심정보 이미지"
                        })
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(schedule_HotelResort, {
                    evCd: evCd
                }),
                (notice.stretAttaFileKey || notice.goodsInfo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* SubTitleWrap */.Ar, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                        children: "상품안내"
                    })
                }),
                notice.stretAttaFileKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* SurchargeBox */.MI, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: handleSearcharge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_surcharge.jpg",
                            alt: "SURCHARGE 이미지"
                        })
                    })
                }),
                notice.goodsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodsInformation, {
                    goodsInfo: notice.goodsInfo
                })
            ]
        })
    });
};
// subTab 핵심정보
var Information = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Information Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var schedule_Information = (Information);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/style/detailpackage/option.tsx
var detailpackage_option = __webpack_require__(73829);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventOptionalTourDetail.ts
var useEventOptionalTourDetail = __webpack_require__(39810);
// EXTERNAL MODULE: ./hooks/services/queries/bff/useEventTourDetail.ts
var bff_useEventTourDetail = __webpack_require__(54804);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/Option.tsx












var OptionComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useEventOptTourDtl = (0,useEventOptionalTourDetail/* default */.Z)(evCd);
    var useEventTourDtl = (0,bff_useEventTourDetail/* default */.Z)(evCd);
    var evtOptTourDtl = (ref = useEventOptTourDtl.data) === null || ref === void 0 ? void 0 : ref.body;
    var option = (evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.optionList) || [];
    var optionalTour = useEventTourDtl.data.optionalTour;
    var ListOptionRef = (0,react.useRef)([]);
    var ListTourRef = (0,react.useRef)([]);
    // toggle list
    var ref1 = (0,react.useState)([]), optionExpand = ref1[0], setOptionExpand = ref1[1];
    var ref2 = (0,react.useState)([]), travelExpand = ref2[0], setTravelExpand = ref2[1];
    var handleToggleOption = function(index) {
        var newState = (0,_to_consumable_array/* default */.Z)(optionExpand);
        if (newState.includes(index)) {
            setOptionExpand(newState.filter(function(i) {
                return i !== index;
            }));
        } else {
            newState.push(index);
            setOptionExpand(newState);
        }
    };
    var handleToggleTravel = function(index) {
        var newState = (0,_to_consumable_array/* default */.Z)(travelExpand);
        if (newState.includes(index)) {
            setTravelExpand(newState.filter(function(i) {
                return i !== index;
            }));
        } else {
            newState.push(index);
            setTravelExpand(newState);
        }
    };
    // 옵션 전체 버튼
    var handleToggleAllOption = function() {
        optionExpand.length === option.length && setOptionExpand([]);
        optionExpand.length !== option.length && setOptionExpand(option.map(function(o, i) {
            return i;
        }));
    };
    // 선택관광 전체 버튼
    var handleToggleAllTravel = function() {
        travelExpand.length === optionalTour.data.length && setTravelExpand([]);
        travelExpand.length !== optionalTour.data.length && setTravelExpand(optionalTour.data.map(function(o, i) {
            return i;
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            option.length === 0 && !optionalTour.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ContentTitleWrap */.n2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ContentTitle */.wW, {
                            children: "옵션"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* List */.aV, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* TextNone */.Bh, {
                                children: "해당 상품은 옵션이 포함되지 않습니다."
                            })
                        })
                    })
                ]
            }),
            option.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ContentTitleWrap */.n2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ContentTitle */.wW, {
                                children: "옵션"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ButtonWrap */.Ls, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                    onClick: handleToggleAllOption,
                                    text: optionExpand.length === option.length ? "전체닫기" : "전체열기",
                                    size: "default"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* List */.aV, {
                        children: option.map(function(item, index) {
                            var ref;
                            var imageUrl = item.imageUrl, intro = item.intro, title = item.title, cost = item.cost, useTm = item.useTm, note = item.note;
                            var accompanyYn = item.accompanyYn, waitingArea = item.waitingArea, waitingSche = item.waitingSche;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ListItem */.HC, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ListContent */.yq, {
                                        onClick: function() {
                                            return handleToggleOption(index);
                                        },
                                        isActive: optionExpand.includes(index),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ListTitle */.AO, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    children: title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* PriceWrap */.PS, {
                                                children: [
                                                    cost && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Price */.tA, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "비용"
                                                            }),
                                                            cost
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* MoreButton */.zw, {
                                                        isActive: optionExpand.includes(index),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "더보기"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ListDetail */.yk, {
                                        contentHeight: (ref = ListOptionRef.current[index]) === null || ref === void 0 ? void 0 : ref.clientHeight,
                                        isActive: optionExpand.includes(index),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            ref: function(el) {
                                                return ListOptionRef.current[index] = el;
                                            },
                                            children: [
                                                imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* Thumbnail */.pl, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                                        width: "190px",
                                                        height: "auto",
                                                        src: imageUrl,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* TextBox */.zC, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: intro
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Summary */.ER, {
                                                            children: [
                                                                cost && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                            children: "비용"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                                                children: cost
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                useTm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                            children: "소요시간"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                                                children: useTm
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        accompanyYn && waitingArea && waitingSche && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Note */.jC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "미참가시"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                                                                children: "미참가시"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                                                        style: {
                                                                                            width: "33.333%"
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                                                        style: {
                                                                                            width: "33.333%"
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                                                        style: {
                                                                                            width: "33.333%"
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            scope: "col",
                                                                                            children: "대기일정"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            scope: "col",
                                                                                            children: "대기장소"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                            scope: "col",
                                                                                            children: "가이드동행여부"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            style: {
                                                                                                textAlign: "center"
                                                                                            },
                                                                                            children: waitingSche
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            style: {
                                                                                                textAlign: "center"
                                                                                            },
                                                                                            children: waitingArea
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                            style: {
                                                                                                textAlign: "center"
                                                                                            },
                                                                                            children: accompanyYn
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        note && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Note */.jC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    children: "참고사항"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: note.replace(/\r\n/g, "<br/>")
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* AditorCaution */.fx, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                            dangerouslySetInnerHTML: {
                                __html: evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.optionalTourInfo.optInfo
                            }
                        })
                    })
                ]
            }),
            optionalTour.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ContentTitleWrap */.n2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ContentTitle */.wW, {
                                children: "선택관광"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ButtonWrap */.Ls, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                    onClick: handleToggleAllTravel,
                                    text: travelExpand.length === optionalTour.data.length ? "전체닫기" : "전체열기",
                                    size: "default"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* List */.aV, {
                        children: optionalTour.data.map(function(item, index) {
                            var ref;
                            var trvInfoNm = item.trvInfoNm, optCost = item.optCost, trvContent = item.trvContent, image1Url = item.image1Url, useTm = item.useTm;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ListItem */.HC, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* ListContent */.yq, {
                                        onClick: function() {
                                            return handleToggleTravel(index);
                                        },
                                        isActive: optionExpand.includes(index),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ListTitle */.AO, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    children: trvInfoNm
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* PriceWrap */.PS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Price */.tA, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "비용"
                                                            }),
                                                            optCost
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* MoreButton */.zw, {
                                                        isActive: travelExpand.includes(index),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "더보기"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* ListDetail */.yk, {
                                        contentHeight: (ref = ListTourRef.current[index]) === null || ref === void 0 ? void 0 : ref.clientHeight,
                                        isActive: travelExpand.includes(index),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            ref: function(el) {
                                                return ListTourRef.current[index] = el;
                                            },
                                            children: [
                                                image1Url && /*#__PURE__*/ (0,jsx_runtime.jsx)(detailpackage_option/* Thumbnail */.pl, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                                        width: "190px",
                                                        height: "130px",
                                                        src: image1Url,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* TextBox */.zC, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Summary */.ER, {
                                                            children: [
                                                                optCost && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                            children: "비용"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                                                children: optCost
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                useTm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                            children: "소요시간"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                                                children: useTm
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        trvContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailpackage_option/* Note */.jC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    children: "참고사항"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: trvContent.replace(/\r\n/g, "<br/>")
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var Option = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Option Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var schedule_Option = (Option);

// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/schedule/ReferTabs.tsx
var ReferTabs = __webpack_require__(85419);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventDetail.ts
var useEventDetail = __webpack_require__(7682);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/schedule/Shopping.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	height: 60px;\n	border-top: 1px solid var(--line-color);\n	border-bottom: 1px solid var(--line-color);\n	align-items: center;\n	justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ContentTitle = (0,styled_components_browser_esm["default"])(desktop_text/* SubTitle */.DK).withConfig({
    componentId: "sc-c32ed603-0"
})(_templateObject());
var TextNone = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c32ed603-1"
})(_templateObject1());
var ShoppingComponent = function(param) {
    var evCd = param.evCd;
    var ref, ref1;
    /** 쇼핑 */ var useEventOptTourDtl = (0,useEventOptionalTourDetail/* default */.Z)(evCd);
    var evtOptTourDtl = (ref = useEventOptTourDtl.data) === null || ref === void 0 ? void 0 : ref.body;
    var shop = (evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.shopList) || [];
    /** 행사 정보 조회 */ var shopCnt = ((ref1 = (0,useEventDetail/* default */.ZP)(evCd).data) === null || ref1 === void 0 ? void 0 : ref1.body.shopCnt) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentTitle, {
                children: "쇼핑"
            }),
            shop.length === 0 && !(evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.optionalTourInfo.shopInfo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextNone, {
                children: "해당 상품은 쇼핑센터 방문이 포함되지 않습니다."
            }),
            shop.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "아래 쇼핑 품목 중 총 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* BlueText */.IW, {
                                children: [
                                    shopCnt,
                                    "번"
                                ]
                            }),
                            "의 쇼핑센터 방문이 일정에 포함되어 있습니다.(쇼핑 품목은 여행일정에 따라 달라질 수 있습니다.)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                        margin: "15px 0 0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "개인정보 처리방침 개정 안내"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "70px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "180px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "140px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "180px"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: "회차"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: "쇼핑 품목"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: "쇼핑 장소"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: "소요시간"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: "환불여부"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: shop.length > 0 && shop.map(function(item, index) {
                                        var shopNm = item.shopNm, shopPlace = item.shopPlace, shopTm = item.shopTm, refundNote = item.refundNote;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: index + 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: shopNm
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: shopPlace
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: shopTm
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: refundNote
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            (evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.optionalTourInfo.shopInfo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                margin: "20px 0",
                dangerouslySetInnerHTML: {
                    __html: evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.optionalTourInfo.shopInfo
                }
            })
        ]
    });
};
var Shopping = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Shopping Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var schedule_Shopping = (Shopping);

// EXTERNAL MODULE: ./hooks/services/queries/portal/useReviewSummary.ts
var useReviewSummary = __webpack_require__(56088);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailSchedule.tsx


















var ScheduleTab = function(props) {
    var evCd = props.evCd, tabs = props.tabs, _isLast = props.isLast, isLast = _isLast === void 0 ? false : _isLast;
    if (!tabs) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var ref = (0,react.useState)(0), activeTab = ref[0], setActiveTab = ref[1];
    var ScrollToId = function(id) {
        return function(e) {
            e.preventDefault();
            var element = document.getElementById(id);
            if (element) element.scrollIntoView({
                behavior: "smooth"
            });
        };
    };
    var handleScroll = (0,react.useCallback)(function() {
        var contentsElements = Array.from(document.querySelectorAll("[id^=secondContents]"));
        contentsElements.forEach(function(el, index) {
            if (el && window.scrollY + 166 > window.scrollY + el.getBoundingClientRect().top) {
                setActiveTab(index);
            }
        });
        if (!isLast) return;
        var scrollHeight = document.documentElement.scrollHeight;
        var scrollTop = document.documentElement.scrollTop;
        var clientHeight = document.documentElement.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight) {
            setActiveTab(contentsElements.length - 1);
        }
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* ScrollTabList */.dR, {
                children: tabs.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* ScrollTabItem */.KR, {
                            href: "secondContents".concat(index),
                            isActive: activeTab === index,
                            onClick: ScrollToId("secondContents".concat(index)),
                            children: item.title
                        })
                    }, index);
                })
            }),
            tabs.map(function(item, index) {
                var Contents = item.contents;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* ScrollContent */.MV, {
                    id: "secondContents".concat(index),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, {
                        evCd: evCd
                    })
                }, index);
            })
        ]
    });
};
var ScheduleFirstComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var goodsCd = evCd.substring(0, 7);
    var useNotice = (0,useEventNotice/* default */.ZP)(evCd);
    var ref1 = (0,react.useState)([]), tabs = ref1[0], setTabs = ref1[1];
    var notice = (ref = useNotice.data) === null || ref === void 0 ? void 0 : ref.body;
    var useScheTrip = (0,useEventScheduleTrip/* default */.Z)(evCd, goodsCd);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (useNotice.isFetching || useScheTrip.isFetching) return;
        var _tabs = [];
        if (notice) _tabs.push({
            title: "핵심정보",
            contents: schedule_Information
        });
        if ((notice === null || notice === void 0 ? void 0 : notice.inclInfo) || (notice === null || notice === void 0 ? void 0 : notice.notinclInfo)) _tabs.push({
            title: "포함/불포함/약관",
            contents: ReferTabs/* Notice */.qX
        });
        if (((ref = useScheTrip.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.scheduleDetail.length) > 0) _tabs.push({
            title: "일차별 일정",
            contents: schedule_DailySchedule
        });
        setTabs(_tabs);
    }, [
        useNotice.isFetching,
        useScheTrip.isFetching
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tabs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleTab, {
            tabs: tabs,
            evCd: evCd
        })
    });
};
/**
 * 핵심정보 | 포함/불포함 | 일차별 일정
 */ var ScheduleFirst = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailSchedule ScheduleFirst Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleFirstComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/**
 * 옵션/선택관광 | 쇼핑 | 숙소 | 관광지 | 즐길거리 | 먹거리
 */ var ScheduleSecond = function(param) {
    var evCd = param.evCd;
    var ref = (0,react.useState)([]), tabs = ref[0], setTabs = ref[1];
    var useEventOptTourDtl = (0,useEventOptionalTourDetail/* default */.Z)(evCd);
    var useEventTourDtl = (0,bff_useEventTourDetail/* default */.Z)(evCd);
    (0,react.useEffect)(function() {
        if (useEventOptTourDtl.isFetching || useEventTourDtl.isFetching) return;
        var _data = useEventTourDtl.data, accommodation = _data.accommodation, tourSpot = _data.tourSpot, entertainment = _data.entertainment, food = _data.food;
        var _tabs = [];
        _tabs.push({
            title: "옵션/선택관광",
            contents: schedule_Option
        });
        _tabs.push({
            title: "쇼핑",
            contents: schedule_Shopping
        });
        if (accommodation.show) _tabs.push({
            title: accommodation.title,
            contents: TemplateTabs/* Accommodation */.sE
        });
        if (tourSpot.show) _tabs.push({
            title: tourSpot.title,
            contents: TemplateTabs/* TourlistDestination */.Al
        });
        if (entertainment.show) _tabs.push({
            title: entertainment.title,
            contents: TemplateTabs/* Enjoy */.aM
        });
        if (food.show) _tabs.push({
            title: food.title,
            contents: TemplateTabs/* Food */.jr
        });
        setTabs(_tabs);
    }, [
        useEventOptTourDtl.isFetching,
        useEventTourDtl.isFetching
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tabs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleTab, {
            tabs: tabs,
            evCd: evCd
        })
    });
};
/**
 * 참고/전달사항 | 유의 사항 | 약관 / 취소수수료 | 여권/비자 | 여행자보험 | 해외여행 안전정보
 */ var ScheduleThird = function(param) {
    var evCd = param.evCd;
    var ref;
    var ref1 = (0,react.useState)([]), tabs = ref1[0], setTabs = ref1[1];
    var useNotice = (0,useEventNotice/* default */.ZP)(evCd);
    var notice = (ref = useNotice.data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react.useEffect)(function() {
        if (useNotice.isFetching) return;
        var _tabs = [];
        if ((notice === null || notice === void 0 ? void 0 : notice.miscInfo) || (notice === null || notice === void 0 ? void 0 : notice.essenInfo)) {
            _tabs.push({
                title: "참고/전달사항",
                contents: ReferTabs/* Refer */.xU
            });
        }
        _tabs.push({
            title: "유의 사항",
            contents: ReferTabs/* Importance */.Hw
        });
        if (notice === null || notice === void 0 ? void 0 : notice.passportInfo) _tabs.push({
            title: "여권/비자",
            contents: ReferTabs/* PassportandVisa */.eb
        });
        _tabs.push({
            title: "여행자보험",
            contents: ReferTabs/* Insurance */.iS
        });
        _tabs.push({
            title: "해외여행 안전정보",
            contents: ReferTabs/* Safety */.Vn
        });
        setTabs(_tabs);
    }, [
        useNotice.isFetching
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tabs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleTab, {
            tabs: tabs,
            evCd: evCd
        })
    });
};
/** 고객리뷰 | 여행후기 */ var ScheduleFourth = function(param) {
    var evCd = param.evCd;
    var tabs = [
        {
            title: "고객리뷰",
            contents: Review/* default */.Z
        },
        {
            title: "여행후기",
            contents: schedule_Episode
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleTab, {
        tabs: tabs,
        evCd: evCd,
        isLast: true
    });
};
var DetailScheduleComponent = function(props) {
    var ref;
    var evCd = props.evCd, _useScheduleView = props.useScheduleView, useScheduleView = _useScheduleView === void 0 ? false : _useScheduleView;
    var ref1 = (0,react.useState)(0), activeFirstTab = ref1[0], setActiveFirstTab = ref1[1];
    var reviewSummaryFetch = (0,useReviewSummary/* default */.ZP)(evCd.split("-")[0]);
    var reviewSummary = (ref = reviewSummaryFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var ref2 = (0,react.useState)([]), tabs = ref2[0], setTabs = ref2[1];
    (0,react.useEffect)(function() {
        if (reviewSummaryFetch.isFetching) return;
        var _tabs = [];
        _tabs.push({
            title: "상품정보/일정",
            contents: ScheduleFirst
        });
        _tabs.push({
            title: "옵션/쇼핑/관광",
            contents: ScheduleSecond
        });
        _tabs.push({
            title: "참고사항",
            contents: ScheduleThird
        });
        var ref;
        !useScheduleView && _tabs.push({
            title: "리뷰 (".concat((ref = reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.reviewCnt) !== null && ref !== void 0 ? ref : 0, ")"),
            contents: ScheduleFourth
        });
        setTabs(_tabs);
    }, [
        reviewSummaryFetch.isFetching
    ]);
    var scrollToTop = function(index) {
        return function(e) {
            e.preventDefault();
            setActiveFirstTab(index);
            var element = document.querySelector("#__scheduleTop");
            element.scrollIntoView({
                behavior: "smooth"
            });
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productinformation/* Wrap */.Eq, {
            id: "__scheduleTop",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* TopNavi */.Pv, {
                    children: tabs.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* TopNaviItem */.mf, {
                                href: "#content".concat(index),
                                onClick: scrollToTop(index),
                                isActive: activeFirstTab === index,
                                children: item.title
                            })
                        }, index);
                    })
                }),
                tabs.map(function(item, index) {
                    var Contents = item.contents;
                    return activeFirstTab === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(productinformation/* Content */.VY, {
                        id: "content".concat(index),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, {
                            evCd: evCd
                        })
                    }, index);
                })
            ]
        })
    });
};
var DetailSchedule = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailSchedule Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailScheduleComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailSchedule = (DetailSchedule);


/***/ }),

/***/ 75907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ TabItem; },
/* harmony export */   "Eq": function() { return /* binding */ Wrap; },
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "V_": function() { return /* binding */ HotelInfoWrap; }
/* harmony export */ });
/* unused harmony export TableWrap */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	margin: 60px auto 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	margin-top: 10px;\n	margin-bottom: 40px;\n	border-bottom: 1px solid var(--line-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n					font-weight: bold;\n					color: var(--emp-color);\n					&::after {\n						position: absolute;\n						right: 0;\n						bottom: -1px;\n						z-index: 1;\n						display: block;\n						width: 100%;\n						height: 3px;\n						background-color: var(--yellow-color);\n						content: "";\n					}\n			  '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n	padding: 20px 0;\n	&:not(:last-child) {\n		margin-right: 30px;\n	}\n	font-size: var(--default-size);\n	color: var(--gray-color);\n	cursor: pointer;\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: ",
        ";\n	padding: 35px 40px 40px;\n	border: 1px solid var(--line-color);\n\n	> h4 {\n		padding-bottom: 20px;\n		margin-bottom: 20px;\n		border-bottom: 1px dashed var(--line-color);\n		font-size: var(--medium-size);\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 40px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-5af1d5dd-0"
})(_templateObject());
var Tab = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    componentId: "sc-5af1d5dd-1"
})(_templateObject1());
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    componentId: "sc-5af1d5dd-2"
})(_templateObject3(), function(props) {
    return props.active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2()) : "";
});
var HotelInfoWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-5af1d5dd-3"
})(_templateObject4(), function(props) {
    return props.active ? "block" : "none";
});
var TableWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-5af1d5dd-4"
})(_templateObject5());



/***/ }),

/***/ 99839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 여행 후기 상세 조회
 *   `/pkg/review/by-goods/{goodsCd}/episode`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useReviewEpisode";
var getPath = function(goodsCd) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/review/by-goods/").concat(goodsCd, "/episode");
};
/** ```
 * 여행 후기 상세 조회
 *   `/pkg/review/by-goods/{goodsCd}/episode`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewEpisode = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewEpisode);



/***/ })

}]);